import React from 'react';
import FindCustomerContainer from 'features/FindCustomer';

const FindCustomerPage = () => <FindCustomerContainer />;

export default FindCustomerPage;
